import { render, staticRenderFns } from "./page-sale-view.vue?vue&type=template&id=6e35e641&scoped=true&"
import script from "./page-sale-view.vue?vue&type=script&lang=js&"
export * from "./page-sale-view.vue?vue&type=script&lang=js&"
import style0 from "./page-sale-view.vue?vue&type=style&index=0&id=6e35e641&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35e641",
  null
  
)

export default component.exports